"use strict";

exports.onInitialClientRender = function () {
  if (process.env.NODE_ENV === "production" && typeof Intercom === "function" && window.IntercomAppId) {
    window.Intercom("boot", {
      app_id: window.IntercomAppId
    });
  }
};

exports.onRouteUpdate = function (_ref) {
  var location = _ref.location;

  if (process.env.NODE_ENV === "production" && typeof Intercom === "function" && window.IntercomAppId) {
    window.Intercom("update");
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-intercom-spa/gatsby-browser.js
// module id = 346
// module chunks = 231608221292675